import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrderDTO } from '../../types/apiType';

export interface OrderState {
  selectedOrder: OrderDTO | null;
  orders: OrderDTO[];
}

const initialState: OrderState = {
  orders: [],
  selectedOrder: null,
};

export const orderSlice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    setSelectedOrder: (state, action: PayloadAction<OrderDTO | null>) => {
      state.selectedOrder = action.payload;
    },
    setOrders: (state, action: PayloadAction<OrderDTO[]>) => {
      state.orders = action.payload;
    },
  },
});

export const { setSelectedOrder, setOrders } = orderSlice.actions;

export default orderSlice.reducer;
